/**
 * Created by Bazu-05 on 12.06.2020.
 */

export const preloader = {
    state: {
        loader: false,
    },
    actions: {},
    mutations: {
        SET_LOADER(state, payload) {
            state.loader = payload
        }
    },
    getters: {
        getLoader: state => state.loader
    }
}